import { graphql } from "@/graphql/codegen"

graphql(`
  mutation CancelPayFile($input: PayFileCancelInput!) {
    payFile {
      cancel(input: $input) {
        __typename
        ... on PayFileCancelSuccess {
          payFile {
            payFileId
          }
        }
        ... on PayFileCancelFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
